export default __webpack_public_path__ + "static/media/reparatie_zeil.2a461e82.svg";